export function getOrderConfigOptions(orderConfig) {
  const orderConfigOptions = []

  Object.entries(orderConfig).forEach(([key, value]) => {
    if (key === 'color') {
      orderConfigOptions.push(value.id)
      return
    }

    if (key === 'chargings') {
      Object.values(value).forEach(ids => ids.forEach(id => orderConfigOptions.push(id)))
      return
    }

    if (key === 'extra_equipments') {
      Object.values(value).forEach(ids => ids.forEach(id => orderConfigOptions.push(id)))
      return
    }
  })

  return orderConfigOptions
}
